import { Link, Outlet, createFileRoute, redirect, useNavigate, useRouter } from "@tanstack/react-router";
import { Car, History, Home, LogOut } from "lucide-react";
import { resolveAuthedGate } from "../auth/gate";
import { performSignOut } from "../auth/performSignOut";
import { logEvent } from "../sentry";

export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ context }) => {
    const target = await resolveAuthedGate(context.auth, context.queryClient);
    if (target) throw redirect({ to: target });
  },
  component: AuthedShell,
});

const tabs = [
  { to: "/home", label: "Home", Icon: Home },
  { to: "/history", label: "History", Icon: History },
  { to: "/vehicles", label: "Vehicles", Icon: Car },
] as const;

function AuthedShell() {
  const { auth, queryClient } = Route.useRouteContext();
  const navigate = useNavigate();
  const router = useRouter();
  const signOut = async () => {
    logEvent("signout");
    await performSignOut(auth, queryClient); // firebase sign-out + cache clear + Sentry hygiene
    await router.invalidate();
    await navigate({ to: "/" });
  };

  return (
    <div className="min-h-screen bg-slate-50 pb-16">
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-3">
        <span className="font-semibold text-slate-800">Carwash</span>
        <button onClick={signOut} className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700">
          <LogOut size={16} /> Sign out
        </button>
      </header>
      <Outlet />
      <nav className="fixed inset-x-0 bottom-0 flex border-t border-slate-200 bg-white">
        {tabs.map(({ to, label, Icon }) => (
          <Link key={to} to={to} className="flex flex-1 flex-col items-center gap-0.5 py-2 text-xs text-slate-500 [&.active]:text-teal-600">
            <Icon size={20} /> {label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
